// src/web/client/src/pages/Customers.jsx
//
// Customers — one page for everyone who bought (UX brief, Phase B2): ONE list
// with filters (stage, risk, tier, restock reminder expected) and the one
// Export; the Overview funnel whose stages deep-link into the list; the VIP
// list (Pro+); and the orders.

import React from 'react';
import PageTabs from '@/components/PageTabs';
import PageHeader from '@/components/PageHeader';
import { PlatformGate, PLATFORM_PAGES } from '@/pages/Platform';
import VIPCustomers from '@/components/analytics/VIPCustomers';
import Orders from '@/pages/Orders';

export default function Customers() {
  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        <PageHeader title="Customers" subtitle="Everyone who bought, what we know about them, and what comes next" />
        <PageTabs tabs={[
          { id: 'list', label: 'Customers', render: () => <PlatformGate><PLATFORM_PAGES.customers /></PlatformGate> },
          { id: 'overview', label: 'Overview', render: () => <PlatformGate><PLATFORM_PAGES.lifecycle /></PlatformGate> },
          { id: 'vip', label: 'VIP', render: () => <VIPCustomers /> },
          { id: 'orders', label: 'Orders', render: () => <Orders embedded /> },
        ]} />
      </div>
    </div>
  );
}
